// extracted by mini-css-extract-plugin
module.exports = {"guitars":"guitars_guitars__3A3xR","cards":"guitars_cards__3CFSt","card":"guitars_card__1M2SG","thumbnail":"guitars_thumbnail__3TyJv"};